import React from 'react';
import PropTypes from 'prop-types';

export default function DroppedValuesNotice({ count, onDismiss }) {
  const message = count === 1
    ? 'Loaded. 1 value no longer exists in this convention and was left empty.'
    : `Loaded. ${count} values no longer exist in this convention and were left empty.`;
  return (
    <div className="alert alert-warning">
      <button type="button" className="close" aria-label="Dismiss" onClick={onDismiss}>&times;</button>
      <span>{message}</span>
    </div>
  );
}

DroppedValuesNotice.propTypes = {
  count: PropTypes.number.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
